<div class="body-wrapper">
  <div class="header">
    <app-header (changeMenuSizeClass)="onChangeMenuSizeClass($event)"></app-header>
  </div>

  <div class="content-wrapper">
    <div class="main-menu short-menu">
      <app-nav [(sizeMenuClass)]="menuSizeClass"></app-nav>
    </div>

    <div class="content" [ngClass]="contentClass">
      <xng-breadcrumb class="cust-brcmbs" separator=" ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
          <ng-container>{{ breadcrumb | translate }}</ng-container>
        </ng-container>
      </xng-breadcrumb>

      <div class="body">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
  </div>

  <div class="footer">
    {{ 'home.FOOTER' | translate }} <span> v{{ version }} </span>
  </div>
</div>

<dx-popup [showTitle]="false" [dragEnabled]="true" [closeOnOutsideClick]="false" [resizeEnabled]="false" [width]="'40%'"
  [height]="'60%'" [(visible)]="isRequiredPersonalDataOpen">

  <form (submit)="onSavePrivasy()" *ngIf="isRequiredPersonalDataOpen" action="javascript:void(1);"
    class="tr-form-privasy">
    <div class="warning">
      Для продолжения работы необходимо указать персональные данные!
    </div>
    <div>
      <div class="field-item_privasy">
        <div class="field-label">Фамилия*</div>
        <div class="field">
          <dx-text-box [(value)]="privacy.lastName">
            <dx-validator>
              <dxi-validation-rule type="required"
                [message]="'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED' | translate">
              </dxi-validation-rule>

            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">Имя*</div>
        <div class="field">
          <dx-text-box [(value)]="privacy.firstName">
            <dx-validator>
              <dxi-validation-rule type="required"
                [message]="'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED' | translate">
              </dxi-validation-rule>

            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">Отчество*</div>
        <div class="field">
          <dx-text-box [(value)]="privacy.middleName">
            <dx-validator>
              <dxi-validation-rule type="required"
                [message]="'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED' | translate">
              </dxi-validation-rule>

            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">e-mail</div>
        <div class="field">
          <dx-text-box [(value)]="privacy.email">
            <dx-validator>
              <dxi-validation-rule type="required"
                [message]="'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED' | translate">
              </dxi-validation-rule>

              <dxi-validation-rule type="email" [message]="'employees.EDIT.WRONG_EMAIL' | translate">
              </dxi-validation-rule>

            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">Телефон*</div>
        <div class="field">
          <dx-text-box mask="+7 (000) 000-00-00" [(value)]="privacy.phone">
            <dx-validator>
              <dxi-validation-rule type="required"
                [message]="'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED' | translate">
              </dxi-validation-rule>

            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div>
        <dx-check-box [value]="false">
          <dx-validator>
            <dxi-validation-rule type="required"
            [message]="'Вы должы согласиться на обработку персональных данных'">
          </dxi-validation-rule>
            <!-- <dxi-validation-rule type="compare" 
              [message]="'Вы должы согласиться на обработку персональных данных'">
            </dxi-validation-rule> -->
          </dx-validator>
        </dx-check-box>
        Я даю согласие на обработку <a href=" https://i.tr-portal.ru/l/InStoreWorks/oferts/tr-oferta.pdf" download=""
          target="_blank">персональных данных</a>.
      </div>
      <!-- <dx-validation-summary id="summary-1" class="tr-form-messages errors"></dx-validation-summary> -->
      <div class="button-container">
        <dx-button class="entry-btn" [useSubmitBehavior]="true" [disabled]=" loginLoading"
          [template]="'buttonTemplate'">
          <div *dxTemplate="let buttonData of 'buttonTemplate'">
            <fa-icon *ngIf="loginLoading" [icon]="['fas', 'spinner']" [animation]=" 'spin' "></fa-icon>
            Сохранить
          </div>

        </dx-button>
      </div>
    </div>
  </form>
</dx-popup>
